import React, { useState } from "react";
import "./CheckBox.css";
const CheckBox = ({ defaultChecked, onChange }) => {
  const [checked, setChecked] = useState(defaultChecked | false);
  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setChecked(value);
    onChange && onChange(value);
  };
  return (
    <label className="relative inline-flex h-[20px] w-[20px] cursor-pointer items-center">
      <input
        type="checkbox"
        className="hidden-checkbox hidden"
        checked={checked}
        defaultChecked={checked}
        onChange={handleCheckboxChange}
      />
      <span className={`checkbox-icon ${checked ? "checked" : ""}`}></span>
    </label>
  );
};

export default CheckBox;
